/* eslint-disable react/prop-types */
import React from 'react';

import { graphql } from 'gatsby';

import { BlogPost, BlogPostSchema, SEO } from '@bluefin/components';

import { createSchemaProps } from '../../template-utils';
import { getPageUrl, createPostSlug } from '../../utils';

import './Template.css';

export default function Template({ data, pageContext }) {
  const { fishermanBusiness: business = {}, fishermanBusinessBlogPost: blogPost } = data;

  const {
    name: businessName,
    logo: businessLogo,
    businessCategories = [],
    website,
  } = business || {};

  const {
    title,
    publishedAt,
    gatsbyHeroImage,
    author,
    content,
    summary,
    seoTitle,
    seoDescription,
    seoOgTitle,
    seoOgDescription,
    seoOgImage,
    heroImageAltText,
    slug,
  } = blogPost || {};

  const { blogRootSlug } = pageContext;

  const url = getPageUrl(website, [createPostSlug(blogRootSlug, slug)]);

  const schemaProps = createSchemaProps(blogPost, businessName, businessCategories, businessLogo);

  return (
    <div className="default-blog-wrapper">
      <SEO
        businessName={businessName}
        pageName={title}
        title={seoTitle || title}
        description={seoDescription || summary}
        ogTitle={seoOgTitle}
        ogDescription={seoOgDescription}
        ogImage={seoOgImage}
        ogType="article"
        truncateDescription
        ogUrl={url}
      />
      <BlogPostSchema {...schemaProps} />
      <BlogPost
        title={title}
        heroImage={gatsbyHeroImage && gatsbyHeroImage.childImageSharp}
        heroImageAltText={heroImageAltText}
        publishedAt={publishedAt}
        author={author}
        content={content}
        summary={summary}
        markdown
        blogRootSlug={blogRootSlug}
      />
    </div>
  );
}

export const query = graphql`
  query ($id: Int!) {
    fishermanBusiness {
      name
      logo
      businessCategories {
        category
      }
      website {
        domains {
          url
          primaryDomain
        }
      }
    }
    fishermanBusinessBlogPost(_id: { eq: $id }) {
      _id
      title
      summary
      content
      heroImage
      seoTitle
      seoDescription
      seoOgTitle
      seoOgDescription
      seoOgImage {
        url
        alt
        type
      }
      gatsbyHeroImage {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      author {
        firstName
        lastName
        avatar
        email
      }
      publishedAt
      heroImageAltText
      slug
    }
  }
`;
